import { openDB } from 'idb';

const DB_NAME = 'regulamais_receivings_offline';
const DB_VERSION = 1;
const STORE_NAME = 'drafts';

let dbPromise = null;

const getDb = async () => {
  if (!dbPromise) {
    dbPromise = openDB(DB_NAME, DB_VERSION, {
      upgrade(db) {
        if (!db.objectStoreNames.contains(STORE_NAME)) {
          db.createObjectStore(STORE_NAME, { keyPath: 'id' });
        }
      }
    });
  }
  return dbPromise;
};

const generateId = () => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `draft-${Date.now()}-${Math.random().toString(36).slice(2)}`;
};

export const saveDraft = async (draft) => {
  const db = await getDb();
  const id = draft.id || generateId();
  const timestamp = new Date().toISOString();
  await db.put(STORE_NAME, {
    ...draft,
    id,
    createdAt: draft.createdAt || timestamp,
    updatedAt: timestamp,
    status: draft.status || 'pendente'
  });
  return id;
};

export const getDrafts = async () => {
  const db = await getDb();
  const drafts = await db.getAll(STORE_NAME);
  return drafts.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
};

export const getDraftById = async (id) => {
  const db = await getDb();
  return db.get(STORE_NAME, id);
};

export const deleteDraft = async (id) => {
  const db = await getDb();
  await db.delete(STORE_NAME, id);
};

export const updateDraftStatus = async (id, status, extra = {}) => {
  const db = await getDb();
  const draft = await db.get(STORE_NAME, id);
  if (!draft) return;
  await db.put(STORE_NAME, {
    ...draft,
    ...extra,
    status,
    updatedAt: new Date().toISOString()
  });
};

export const clearDrafts = async () => {
  const db = await getDb();
  await db.clear(STORE_NAME);
};

